<template>
  <div class="login">
    <h1 class="blue-grey--text text-center mt-5">로그인</h1>
    <v-container>
      <v-row justify="center">
        <v-col ols="12" sm="8" md="6" lg="5" xl="4" class="text-center">
          <v-form class="pa-3" v-model="valid" ref="form">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="이메일"
                    required
                    prepend-icon="mdi-account-box-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    type="password"
                    v-model="password"
                    :counter="8"
                    :rules="passwordRules"
                    label="비밀번호"
                    required
                    prepend-icon="mdi-lock-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    dark
                    color="blue-grey lighten-2"
                    @click.prevent="login"
                    :loading="loading"
                    >들어가기</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { auth } from "../firebase/init";

export default {
  name: "Login",
  data: () => ({
    loading: false,
    valid: true,
    password: "",
    passwordRules: [
      (v) => !!v || "비밀번호는 필수에요",
      (v) => (v && v.length <= 8) || "비밀번호는 8자 이내로 만드세요",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "이메일은 필수에요",
      (v) => /.+@.+\..+/.test(v) || "유효한 이메일이 필요해요",
    ],
  }),

  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then((cred) => {
            console.log(cred.user);
            this.$router.push({ name: "Projects" });
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style>
.v-form {
  border: 1px solid #b0bec5;
}
</style>
